import { Category } from "../interfaces/tell_me/category.types";
import { ReelsCategory } from "../interfaces/tell_me_watch/reelsCategory.types";

const getCategoryNamesByIds = (categories: Category[], ids: string[]): Array<string> => {
    const categoryNames = [];
    for (let category of categories) {
        if (ids.includes(category.id)) {
            categoryNames.push(category.name);
        }
    }
    return categoryNames;
}
const getReelCategoryNameById = (categories: ReelsCategory[], categoryId: string): string => {
    return categories.find((val) => val.id === categoryId)?.name ?? "";
}

export {
    getCategoryNamesByIds,
    getReelCategoryNameById
};